
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  RepatriationOpportunityCreationResponse,
  SearchReferralSubmissionRequest,
  SearchReferralSubmissionResponse,
  UpdateReferralSubmissionOpportunityTypeRequest,
  UpdateReferralSubmissionStatusRequest,
} from '../models';
import {
    RepatriationOpportunityCreationResponseFromJSON,
    RepatriationOpportunityCreationResponseToJSON,
    SearchReferralSubmissionRequestFromJSON,
    SearchReferralSubmissionRequestToJSON,
    SearchReferralSubmissionResponseFromJSON,
    SearchReferralSubmissionResponseToJSON,
    UpdateReferralSubmissionOpportunityTypeRequestFromJSON,
    UpdateReferralSubmissionOpportunityTypeRequestToJSON,
    UpdateReferralSubmissionStatusRequestFromJSON,
    UpdateReferralSubmissionStatusRequestToJSON,
} from '../models';

export interface CreateRepatriationOpportunityRequest {
    submissionId: string;
}

export interface SearchSubmissionRequestsRequest {
    searchReferralSubmissionRequest: SearchReferralSubmissionRequest;
}

export interface UpdateOpportunityTypeRequest {
    submissionId: string;
    updateReferralSubmissionOpportunityTypeRequest: UpdateReferralSubmissionOpportunityTypeRequest;
}

export interface UpdateStatusRequest {
    submissionId: string;
    updateReferralSubmissionStatusRequest: UpdateReferralSubmissionStatusRequest;
}

/**
 * 
 */
export class EligibilityApi extends runtime.BaseAPI {

    /**
     * Create a repatriation opportunity from a referral submission
          */
    async createRepatriationOpportunityRaw(requestParameters: CreateRepatriationOpportunityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RepatriationOpportunityCreationResponse>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling createRepatriationOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<RepatriationOpportunityCreationResponse>({
            path: `/business-referral/api/eligibility/{submissionId}/repatriation-opportunity`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=RepatriationOpportunityCreationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Create a repatriation opportunity from a referral submission
          */
    async createRepatriationOpportunity(requestParameters: CreateRepatriationOpportunityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RepatriationOpportunityCreationResponse> {
        const response = await this.createRepatriationOpportunityRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve all eligibility checks for business referrals
          */
    async searchSubmissionRequestsRaw(requestParameters: SearchSubmissionRequestsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SearchReferralSubmissionResponse>> {
        if (requestParameters['searchReferralSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'searchReferralSubmissionRequest',
                'Required parameter "searchReferralSubmissionRequest" was null or undefined when calling searchSubmissionRequests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SearchReferralSubmissionResponse>({
            path: `/business-referral/api/eligibility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchReferralSubmissionRequestToJSON(requestParameters['searchReferralSubmissionRequest']),
        }, initOverrides);

        if (response._data) { response._data=SearchReferralSubmissionResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve all eligibility checks for business referrals
          */
    async searchSubmissionRequests(requestParameters: SearchSubmissionRequestsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SearchReferralSubmissionResponse> {
        const response = await this.searchSubmissionRequestsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update opportunity type when submission will become one
          */
    async updateOpportunityTypeRaw(requestParameters: UpdateOpportunityTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateOpportunityType().'
            );
        }

        if (requestParameters['updateReferralSubmissionOpportunityTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralSubmissionOpportunityTypeRequest',
                'Required parameter "updateReferralSubmissionOpportunityTypeRequest" was null or undefined when calling updateOpportunityType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/opportunity-type`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralSubmissionOpportunityTypeRequestToJSON(requestParameters['updateReferralSubmissionOpportunityTypeRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update opportunity type when submission will become one
          */
    async updateOpportunityType(requestParameters: UpdateOpportunityTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOpportunityTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Update eligibility status
          */
    async updateStatusRaw(requestParameters: UpdateStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateStatus().'
            );
        }

        if (requestParameters['updateReferralSubmissionStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralSubmissionStatusRequest',
                'Required parameter "updateReferralSubmissionStatusRequest" was null or undefined when calling updateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/status`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralSubmissionStatusRequestToJSON(requestParameters['updateReferralSubmissionStatusRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update eligibility status
          */
    async updateStatus(requestParameters: UpdateStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStatusRaw(requestParameters, initOverrides);
    }

}
